import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  fill?: string;
  className?: string;
}

export const StarIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  fill,
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill={fill || 'none'}
    className={className}
  >
    <path
      d='M10 15L3.82 18.18L5.23 11.27L0 6.91L7.09 6.18L10 0L12.91 6.18L20 6.91L14.77 11.27L16.18 18.18L10 15Z'
      stroke={fill ? 'none' : color}
      fill={fill || 'none'}
      strokeWidth='1.5'
    />
  </svg>
);
